import React from "react";
import { DeveloperCard } from "@/components/DeveloperCard";
import { AboutLink } from "@/pages/About";
import { DevicesCard } from "@/components/DevicesCard";
import { PageTitle, SettingsPanel } from "@/components/SettingsPanel";
import { StatusPill } from "@/components/VenueBits";
import { WaTemplatesCard } from "@/components/WaTemplatesCard";
import { AdminWhatsAppButton } from "@/components/PlatformContact";
import { PushToggle } from "@/components/PushToggle";
import { AccountSecurity } from "@/components/AccountSecurity";
import { usePrefs } from "@/contexts/PrefsContext";
import { useAuth } from "@/contexts/AuthContext";
import type { User } from "@/types";

export default function VenueSettings() {
  const { t } = usePrefs();
  const u = useAuth().user as User;
  const acc = u.venue_account;
  return (
    <div data-testid="venue-settings-page">
      <PageTitle title={t("settings.title")} />
      <SettingsPanel>
        {acc && (
          <div className="rounded-3xl border bg-card p-5 space-y-2" data-testid="venue-account-card">
            <p className="text-xs font-bold text-muted-foreground">{t("auth.businessName")}</p>
            <div className="flex items-center justify-between gap-2">
              <p className="font-display text-lg font-bold">{acc.business_name}</p>
              <StatusPill status={acc.status} />
            </div>
            <div className="text-sm text-muted-foreground grid gap-0.5" data-testid="venue-account-details">
              {acc.governorate && <span>{t(`gov.${acc.governorate}`)}</span>}
              {acc.phone && <span dir="ltr" className="text-start">{acc.phone}</span>}
              {acc.status_reason && acc.status !== "approved" && <span><b>{t("status.reason")}:</b> {acc.status_reason}</span>}
            </div>
          </div>
        )}
        <AccountSecurity />
        <DevicesCard />
        {acc?.status === "approved" && ["owner", "reception"].includes(u.venue_role || "") && <WaTemplatesCard />}
        <PushToggle />
        <AdminWhatsAppButton />
        <DeveloperCard />
        <AboutLink className="px-2" />
      </SettingsPanel>
    </div>
  );
}
